import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Parallax */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.squarespace-cdn.com/content/v1/68ebb6751f9d04372e40f528/1761329558856-2WNFM7KJRJH0TIZ1NX5U/unsplash-image-3aGV2ViCzrM.jpg)',
          transform: `translateY(${offsetY * 0.5}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center px-4">
        <div className="text-center text-white animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-serif mb-6 leading-tight animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <span className="block font-sans text-xs md:text-sm tracking-[0.3em] uppercase text-white/90 mb-6" data-testid="hero-midtown-eyebrow">
              Certified Massage Therapist in Midtown Sacramento
            </span>
            Focused, intuitive bodywork
            <br />
            built on experience.
          </h1>
          <p className="text-xl md:text-3xl font-light tracking-widest mb-12 animate-slide-up" style={{ animationDelay: '0.4s' }}>
            Just <span className="inline-block mx-3">real</span> <span className="inline-block mx-3">massages</span> <span className="inline-block mx-3">that</span> <span className="inline-block mx-3">actually</span> <span className="inline-block mx-3">help</span> <span className="inline-block mx-3">you</span> <span className="inline-block mx-3">feel</span> <span className="inline-block mx-3">better.</span>
          </p>
          <button
            onClick={scrollToContact}
            className="bg-white/90 hover:bg-white text-gray-800 px-10 py-4 text-lg tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-2xl animate-slide-up"
            style={{ animationDelay: '0.6s' }}
          >
            Contact us
          </button>
          <div className="mt-6 animate-slide-up" style={{ animationDelay: '0.8s' }}>
            <Link
              to="/massage-midtown-sacramento"
              className="inline-flex items-center gap-2 bg-black/30 backdrop-blur-md border border-white/30 text-white text-sm px-5 py-2 rounded-full hover:bg-black/50 transition-colors duration-300"
              data-testid="hero-midtown-studio-link"
            >
              2528 I Street · Midtown Sacramento →
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;